/**
 * Joins the named surcharges of one ticket into a list (PAUL-3932): "A", "A en B", "A, B, en C".
 * `and` joins a pair; `lastAnd` closes a longer list, so each language keeps its own comma before it.
 */
export function joinSurcharges(parts: string[], and: string, lastAnd: string): string {
  if (parts.length < 3) return parts.join(and);
  return parts.slice(0, -1).join(', ') + lastAnd + parts[parts.length - 1];
}
